export const initLoginState = {
    name: '',
    password:'',
    error:false,
    showForgot:false,
    loading: false
}

export const loginReducer = (state, action) => {
    switch (action.type) {
        case 'name':
            return {...state, login: {...state.login, name: action.payload}};
        case 'password':
            return {...state, login: {...state.login, password: action.payload}};
        case 'error':
            return {...state, login: {...state.login, error: action.payload}};
        case 'showForgot':
            return {...state, login: {...state.login, showForgot: action.payload}};
        case 'loading':
            return {...state, login: {...state.login, loading: action.payload}};
        default: 
            throw new Error(`${action.type} action.type passed to Lineworx reducer is not defined`);
    }
}